import mixpanel from "mixpanel-browser";
import md5 from "md5";

export const initMixpanel = () => {
  const token = import.meta.env.VITE_MIXPANEL_TOKEN;
  if (!token) {
    console.warn("Mixpanel token not found. Analytics disabled.");
    return;
  }
  mixpanel.init(token, {
    ip: 0,
    geolocation: false,
    debug: import.meta.env.DEV,
  });
};

export const identifyUser = (user) => {
  if (!import.meta.env.VITE_MIXPANEL_TOKEN) return;
  if (!user) return;
  const hashedUserId = md5(user.sub);
  if (hashedUserId) {
    mixpanel.identify(hashedUserId);
    mixpanel.people.set({
      $email: user.email,
      $name: user.name,
    });
  }
};

export const resetUser = () => {
  if (!import.meta.env.VITE_MIXPANEL_TOKEN) return;
  mixpanel.reset();
};

export const trackPageView = (pageName, properties = {}) => {
  if (!import.meta.env.VITE_MIXPANEL_TOKEN) return;
  mixpanel.track("Page View", {
    page_name: pageName,
    ...properties,
  });
};

export const trackReportCreation = (properties = {}) => {
  if (!import.meta.env.VITE_MIXPANEL_TOKEN) return;
  mixpanel.track("Report Created", {
    ...properties,
  });
};

export const trackEvent = (eventName, properties = {}) => {
  if (!import.meta.env.VITE_MIXPANEL_TOKEN) return;
  mixpanel.track(eventName, {
    ...properties,
  });
};

export default mixpanel;
